import { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import { apiRequest } from "../utils/http";

const MessagesPage = () => {
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    apiRequest("/api/contact")
      .then((response) => setMessages(response?.data || []))
      .catch((loadError) => setError(loadError.message || "Unable to load contact messages."));
  }, []);

  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="h4" sx={{ mb: 1 }}>Customer Messages</Typography>
        <Typography sx={{ color: "text.secondary" }}>
          Review incoming inquiries from the contact form and prioritize responses.
        </Typography>
      </Box>

      {error && <Alert severity="error">{error}</Alert>}

      <Grid container spacing={3}>
        {messages.map((message) => (
          <Grid item xs={12} md={6} key={message._id}>
            <Card sx={{ height: "100%" }}>
              <CardContent>
                <Stack spacing={1.25}>
                  <Typography variant="h6">{message.fullName || message.name || "Customer message"}</Typography>
                  <Typography sx={{ color: "text.secondary" }}>{message.email || "No email provided"}</Typography>
                  <Typography sx={{ color: "text.secondary", lineHeight: 1.8 }}>
                    {message.message || "No message body."}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default MessagesPage;
